import { createColumnHelper } from '@tanstack/react-table';
import Button from '@/components/UI/Button';

type ReportDetails = {
  generatedBy: string;
  notes: string;
  createdAt: string;
};

const columnHelper = createColumnHelper<ReportDetails>();

export const columns = [
  columnHelper.accessor('generatedBy', {
    header: 'Generated By',
    size: 150,
  }),
  columnHelper.accessor('notes', {
    header: 'Notes',
    size: 300,
  }),
  columnHelper.accessor('createdAt', {
    header: 'Date Created',
    size: 170,
  }),
  columnHelper.display({
    header: 'Actions',
    size: 90,
    cell: ({ row }) => (
      <div>
        <Button btnStyle='btn-primary' label='Download'></Button>
      </div>
    ),
  }),
];
